import Yup from 'configuration/yup';

const validationSchema = Yup.object().shape({
  email: Yup.string().email('Invalid e-mail').required('E-mail is required'),

  phone: Yup.string().required('Phone is required').phoneValidation(),
});

export default validationSchema;
